export default __webpack_public_path__ + "static/images/7d93ed8b34f59385032c092af7f91198.png";